import React, { Component } from "react";

export default React.createContext({
  Bulleten: [],
  // setBulleten,
});
